export default class Channel {
  constructor({ id, name, avatar, banner, description, type }) {
    this.id = id;
    this.name = name;
    this.avatar = avatar;
    this.banner = banner;
    this.description = description;
    this.type = type;
    this.init = false;
    this.error = false;
    this.subscribed = false;
    this.notificationCount = 0;
    this.messages = [];
    this.actions = [];
    // this.typingUsers = [];
    this.nextTimeToken = 0;
    this.actionNextTimeToken = 0;
    this.doneFetching = false;
    this.sticky = true;
  }
}